import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "components/ui/Accordion";
import classNames from "components/ui/classNames";
import React from "react";

type QuestionItem = {
  title: string;
  content: React.ReactNode | string;
};
interface IFrequentlyAskedQuestionsProps {
  questions: QuestionItem[];
}

export default function FrequentlyAskedQuestions({ questions }: IFrequentlyAskedQuestionsProps) {
  return (
    <Accordion type="multiple" className="w-full">
      {questions.map((question) => (
        <AccordionItem key={question.title} value={question.title}>
          <AccordionTrigger
            className={classNames(
              "flex gap-x-4 text-justify font-aeonik text-sm font-medium tracking-wide text-gray-800 xl:text-base",
              "[&[data-state=open]]:font-medium [&[data-state=open]]:text-blue-600",
            )}
          >
            {question.title}
          </AccordionTrigger>
          <AccordionContent>
            <div className="prose flex flex-col text-justify font-aeonik text-xs font-normal text-gray-600 xl:text-base">
              {question.content}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
